import {
  Flex,
  FlexItem,
  InputNumber,
  Panel,
  RadioButton,
  RADIOBUTTON_LABEL_FW_STANDARD,
  SPACING_24,
  SpacingVertical,
  Text,
  Title,
  TITLE_VARIANT_M
} from 'mailup-web-components'
import { taskConditionsState } from 'Pages/Task/recoil/state/task'

import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'

const BoxFrequencySend = () => {
  const intl = useIntl()
  const [
    { FrequencySafeGuard, FrequencySafeGuardHour },
    setTaskConditionsState
  ] = useRecoilState(taskConditionsState)

  const handlerequencySafeGuardHour = (value) => {
    if (value > 0) {
      setTaskConditionsState((prev) => ({
        ...prev,
        FrequencySafeGuardHour: value,
        isDirty: true
      }))
    }
  }

  const onChangeFrequencySafeGuard = (val) => {
    setTaskConditionsState((prev) => ({
      ...prev,
      FrequencySafeGuard: val > 0 ? prev.FrequencySafeGuardHour : val,
      isDirty: true
    }))
  }

  return (
    <>
      <Panel>
        <Title variant={TITLE_VARIANT_M}>
          {intl.formatMessage({ id: 'Load.Task.ConditionsFrequencyTitle' })}
        </Title>
        <SpacingVertical variant={SPACING_24} />
        <Flex alignItems='center'>
          <RadioButton
            label={intl.formatMessage({
              id: 'Load.Task.ConditionsFrequencySetGap'
            })}
            labelVariant={RADIOBUTTON_LABEL_FW_STANDARD}
            checked={FrequencySafeGuard > 0}
            onChange={() => onChangeFrequencySafeGuard(1)}
            data-mu-test='radio-ConditionsFrequencySetGap'
          />
          <FlexItem width='70px' margin='0 8px 0 0'>
            <InputNumber
              min={1}
              value={FrequencySafeGuardHour}
              onChange={handlerequencySafeGuardHour}
              data-mu-test='input-FrequencySafeGuardHour'
            />
          </FlexItem>
          <Text>{intl.formatMessage({ id: 'Load.MailupCommon.Hours' })}</Text>
        </Flex>

        <SpacingVertical variant={SPACING_24} />

        <RadioButton
          label={intl.formatMessage({
            id: 'Load.Task.ConditionsFrequencyOnce'
          })}
          labelVariant={RADIOBUTTON_LABEL_FW_STANDARD}
          checked={FrequencySafeGuard === 0}
          onChange={() => onChangeFrequencySafeGuard(0)}
          data-mu-test='radio-ConditionsFrequencyOncev'
        />

        <SpacingVertical variant={SPACING_24} />

        <RadioButton
          label={intl.formatMessage({
            id: 'Load.Task.ConditionsFrequencyMany'
          })}
          labelVariant={RADIOBUTTON_LABEL_FW_STANDARD}
          checked={FrequencySafeGuard < 0}
          onChange={() => onChangeFrequencySafeGuard(-1)}
          data-mu-test='radio-ConditionsFrequencyMany'
        />
      </Panel>
    </>
  )
}

export default BoxFrequencySend
